import React from 'react';
import styled from 'styled-components';
import { HamburgerMenuIcon as HamburgerMenuIconProps } from './types/types';

const MenuIcon = styled.button<Partial<HamburgerMenuIconProps>>`
  position: fixed;
  top: 1rem;
  left: 24px;
  flex-direction: column;
  background: transparent;
  width: 1.5rem;
  height: 1.5rem;
  border: none;
  justify-content: space-around;
  padding: 0;
  cursor: pointer;
  z-index: 1000;
  display: flex;

  @media (max-width: 768px) {
    top: 8px;
    left: 16px;
  }

  div {
    width: 1.5rem;
    height: 0.18rem;
    border-radius: 5px;
    position: relative;
    transform-origin: 1px;
    background: ${(props: any) => (props.theme.primary)};

    :first-child {
      transform: ${(props) => (props.menuOpen ? 'rotate(45deg)' : 'rotate(0)')};
    }

    :nth-child(2) {
      opacity: ${(props) => (props.menuOpen ? '0' : '1')};
    }

    :nth-child(3) {
      transform: ${(props) => (props.menuOpen ? 'rotate(-45deg)' : 'rotate(0)')};
    }
  }
`;

const HamburgerMenuIcon = ({
  clickCallback, menuOpen,
}: HamburgerMenuIconProps) => {
  return (
    <MenuIcon
      onClick={() => clickCallback()}
      menuOpen={menuOpen}
      data-testid="hamburgerIcon"
    >
      <div />
      <div />
      <div />
    </MenuIcon>
  );
};

export default HamburgerMenuIcon;
